module.exports = __webpack_public_path__ + "static/image@3x-6d18a694397e73240a0a1a8217ca6088.png";